<template>
  <div class="gallery">
    <loader v-if="loading"></loader>

    <section class="top-spacing bg-grey pt-5 mt-5">
      <div class="container">

        <div class="main-heading pb-4">
          <h1 class="title-section">Photo Gallery</h1>
        </div>

        <div class="gride-container" v-if="albums.length">
          <div class="gride-box"
               v-for="album in albums"
               :key="album.album_id">

           <router-link
            :to="{ name: 'GalleryFolders', params: { albumID: album.album_id } }">


              <div class="loader-static">
                <div class="loader-dynamic">
                  <img
                    :src="album.cover_image"
                    @error="$event.target.src='assets/images/placeholder.png'"
                  >
                </div>
                <img src="assets/images/Square.png" class="stactic-img">
              </div>

              <div class="gride-content">
                <h6>{{ album.album_name }}</h6>
              </div>

            </router-link>
          </div>
        </div>

        <div class="nodata" v-else>
          <h1>No Albums Found</h1>
        </div>

        <div class="number-of" v-if="total_pages > 1">
          <button class="btn btn-primary btn-sm"
                  :disabled="current_page === 1"
                  @click="prevPage">Prev</button>

          {{ current_page }} / {{ total_pages }}

          <button class="btn btn-primary btn-sm"
                  :disabled="current_page === total_pages"
                  @click="nextPage">Next</button>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
import { HTTP } from '../../_helper/http-constants.js';

export default {
  name: "Gallery",
  data() {
    return {
      albums: [],
      loading: false,
      current_page: 1,
      total_pages: 1,
      limit: 50
    }
  },
  methods: {
    fetchAlbums() {
      this.loading = true;
      HTTP.get(`/gallery/albums?page=${this.current_page}&limit=${this.limit}`)
        .then(res => {
          if (res.data.status === 200) {
            this.albums = res.data.data;
            this.current_page = res.data.current_page;
            this.total_pages = res.data.total_pages;
          }
          this.loading = false;
        })
        .catch(() => this.loading = false);
    },
    nextPage() {
      if (this.current_page < this.total_pages) {
        this.current_page++;
        this.fetchAlbums();
      }
    },
    prevPage() {
      if (this.current_page > 1) {
        this.current_page--;
        this.fetchAlbums();
      }
    }
  },
  mounted() {
    this.fetchAlbums();
  }
}
</script>
